import lang from "@/views/modules/Notifications/language/en";

//import Editor from '@tinymce/tinymce-vue';

export default {
    name: "new-notification",
   
    components: {
     //   'editor': Editor,
    },
    data() {
        return {
            loading: true,
            notification: {},
            lang:[],
        }
    },
    mounted() {
        this.lang = lang;
    },
    methods: {
        saveNotification() {
            const self = this;
            self.loading = true;
            axios.post('api/modules/notifications', self.notification).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/notifications/' + response.data.notification.id + '/edit');
            }).catch(function () {
                self.loading = false;
            });
        },
    }
}